var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('div',{staticClass:"bg pic-full"}),_c('div',{staticClass:"home"},[_c('main',{staticClass:"fee-main"},[_c('fee-content',{staticClass:"fee-content"})],1)]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }